<template>
  <modal ref="modal" contentClasses="px-5 py-4" :hidesOnClickOut="false">
    <template v-slot:header>
      <p class="font-weight-semibold text-center">Accetta cliente</p>
    </template>

    <template v-slot>
      <content-loading
        :active.sync="acceptPlaceRequest.loading"
        :is-full-page="false"
        v-if="acceptPlaceRequest"
      />
      <display-errors :tag="requestTag"></display-errors>
      <div class="row">
        <div class="col-12">
          <div class="form-group">
            <label>Agente consegnatario</label>
            <user-select
              placeholder="Seleziona un agente"
              :idSelected="payload.consigneeId"
              :params="{ role: 'agent' }"
              :dataKeys="['consigneeId']"
              formClass="grey"
              @change="onDataUpdated"
              :onlyActive="true"
            />
          </div>
        </div>
        <div class="col-12" v-if="payload.version === 1">
          <div class="form-group">
            <label>Tipo di contratto</label>
            <contract-type-select
              :dataKeys="['contractTypeId']"
              formClass="grey"
              :idSelected="place.order.contractTypeId || payload.contractTypeId"
              @change="onDataUpdated"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Fido (in giorni)</label>
            <input
              v-model="payload.creditDays"
              class="form-control grey"
              type="number"
            />
          </div>
        </div>
        <div class="col-12" v-if="payload.version === 1">
          <div class="form-group">
            <label>Anni di contratto</label>
            <input
              v-model="payload.contractYears"
              class="form-control grey"
              type="number"
            />
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label>Note</label>
            <textarea
              style="resize: none"
              v-model="payload.acceptNotes"
              class="form-control grey"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="row w-100">
        <div class="col-6 pl-0">
          <button
            type="button"
            class="btn btn-outline-primary w-100"
            @click.prevent="onCancel"
          >
            Annulla
          </button>
        </div>
        <div class="col-6 pr-0">
          <button
            type="submit"
            class="btn btn-primary w-100"
            @click.prevent="acceptPlace"
            :disabled="!valid || acceptPlaceRequest.loading"
          >
            Accetta cliente
          </button>
        </div>
      </div>
    </template>
  </modal>
</template>

<script lang="ts">
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import PlacesMixin from "mixins/http/PlacesMixin";
import { RegisterHttp } from "utils/Decorators";
import { RequestData } from "store/types";
import Modal from "components/Modal.vue";
import UserSelect from "components/User/Select.vue";
import Loader from "vue-spinner/src/PulseLoader.vue";
import PaymentMethodSelect from "components/PaymentMethod/Select.vue";
import ContractTypeSelect from "components/ContractType/Select.vue";
import { Place } from "models";
import { showToast } from "utils/Toast";

@Component({
  components: {
    Modal,
    Loader,
    UserSelect,
    PaymentMethodSelect,
    ContractTypeSelect,
  },
})
export default class AcceptPlace extends Mixins(PlacesMixin) {
  static readonly acceptPlaceTag = "accept_place";

  @Prop()
  readonly place!: Place;
  payload: any = {
    consigneeId: this.place.agent.id,
    creditDays: this.place.order.creditDays,
    paymentMethodId: (this.place.order as any).paymentMethodId,
    contractTypeId: (this.place.order as any).contractTypeId,
    version: (this.place as any).version,
    acceptNotes: "",
  };

  @RegisterHttp(AcceptPlace.acceptPlaceTag) acceptPlaceRequest: RequestData;

  get valid() {
    return (
      this.payload.creditDays &&
      this.payload.consigneeId &&
      ((this.payload.contractYears && this.place.version === 1) ||
        this.place.version > 1) &&
      ((this.payload.contractTypeId && this.place.version === 1) ||
        this.place.version > 1)
    );
  }

  get requestTag() {
    return AcceptPlace.acceptPlaceTag;
  }

  show() {
    const modal = this.$refs.modal as any;
    modal.show();
  }

  onDataUpdated(data) {
    this.payload = { ...this.payload, ...data };
  }

  hide() {
    const modal = this.$refs.modal as any;
    modal.hide();
  }

  reset() {
    this.payload = {};
  }

  acceptPlace() {
    let data = {
      id: this.place.id,
      ...this.payload,
    };

    this.accept(data, AcceptPlace.acceptPlaceTag).then((resp) => {
      this.onSaved();
      showToast("Contatto accettato con successo!");
    });
  }

  onSaved() {
    this.reset();
    this.hide();
    this.$emit("accepted");
  }

  onCancel() {
    this.payload.contractTypeId = null;
    this.payload.contractYears = null;
    this.hide();
    this.$emit("canceled");
  }
}
</script>

<style scoped></style>
